import * as React from 'react'

import Head from '@/components/Layout/Head'
import { Flex } from '@chakra-ui/react'

const Layout = ({ children, title }) => (
  <>
    <Head title={title} />
    <Flex h="100vh" bg="blackAlpha.50" justify="center" align="center">
      {children}
    </Flex>
  </>
)

export default Layout
